module.exports = __webpack_public_path__ + "img/m-icon3.53d64f28.png";